export default "__VITE_ASSET__93b3880e__"